import React, {FC} from 'react';
import {
  Link as RouterLink,
  LinkProps as ReactLinkProps,
} from '@aboutyou/router';
import {Link as LinkProps} from '@aboutyou/grpc-clients/tadarida/aysa_api/features/link/v1/link.types';

interface HtmlLinkProps {
  onClick?: ReactLinkProps['onClick'];
  className?: string;
}

export const Link: FC<
  React.PropsWithChildren<Omit<LinkProps, 'color'> & HtmlLinkProps>
> = ({label, linkTarget, children, ...rest}) => {
  return (
    <RouterLink to={linkTarget!.url} {...rest}>
      {label || children || linkTarget!.url}
    </RouterLink>
  );
};

/**
 * There are many use cases, where one needs to wrap a component in a link if a href is present.
 * If href evaulates to falsy value, return children without any link.
 */
interface ConditionalLinkProps extends LinkProps {
  condition: boolean;
  children: React.ReactElement;
}

export const ConditionalLink: FC<
  React.PropsWithChildren<ConditionalLinkProps>
> = ({condition, children, ...rest}) =>
  condition ? <Link {...rest}>{children}</Link> : children;
